// SVGs must be imported from within src to be used as React components
import ArrowDown from "assets/svg/icons/arrow-down.svg";
import ArrowLeft from "assets/svg/icons/arrow-left.svg";
import ArrowRight from "assets/svg/icons/arrow-right.svg";
import Calendar from "assets/svg/icons/calendar.svg";
import Check from "assets/svg/icons/check.svg";
import Cross from "assets/svg/icons/cross.svg";
import HeartGray from "assets/svg/icons/gray-heart.svg";
import HeartBright from "assets/svg/icons/heart-bright.svg";
import Heart from "assets/svg/icons/heart.svg";
import Info from "assets/svg/icons/info.svg";
import Menu from "assets/svg/icons/menu.svg";
import NoApartments from "assets/svg/icons/no-apartment.svg";
import Play from "assets/svg/icons/play.svg";
import Share from "assets/svg/icons/share.svg";
import SignpostBig from "assets/svg/icons/signpost-big.svg";
import TooltipTails from "assets/svg/icons/tooltip-tail.svg";
import User from "assets/svg/icons/user.svg";
import WandSparkles from "assets/svg/icons/wand-sparkles.svg";

export interface IconProps {
  name: keyof typeof iconMap;
}

const iconMap = {
  heart: Heart,
  "arrow-down": ArrowDown,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  check: Check,
  cross: Cross,
  "heart-bright": HeartBright,
  info: Info,
  menu: Menu,
  play: Play,
  share: Share,
  "signpost-big": SignpostBig,
  user: User,
  "wand-sparkles": WandSparkles,
  "tooltip-tail": TooltipTails,
  "heart-gray": HeartGray,
  "no-apartments": NoApartments,
  calendar: Calendar,
};

export const Icon = ({ name }: IconProps) => {
  const SvgIcon = iconMap[name];
  return <SvgIcon />;
};
